import type { AppConfig } from './app-config';

/**
 * Configuration du mode branché : les écrans qui le supportent lisent et écrivent dans
 * `Unipros.Pin.Api`. Substitué à `app-config.value.ts` par la configuration de build `api`.
 */
export const APP_CONFIG: AppConfig = {
  dataSource: 'api',
  apiBaseUrl: '/api',
};
